<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
    <div id="mallGoodsDetails">
       <div class="goods-top">
                <div class="swiper-container goodsBanner" style="height: 6.9rem;">
                    <swiper :options="swiperOption" ref="mySwiper" style="height:100%;">
                        <swiper-slide v-for="(img, index) in groupInfo.thumbs" :key="index">
                            <img  :src="img"  alt="">
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-pagination" slot="pagination"></div>
                </div>
                <div class="info">
                    <h3 class="title text-overflow_2-xzh"><span class="status" v-if="shopInfoTypeInfo.title">{{shopInfoTypeInfo.title}}</span>{{groupInfo.goodsName}}</h3>
                    <div class="price">
                        <p><span><i>¥</i>{{groupInfo.spe_price || '0.00'}}</span><del v-if="Number(groupInfo.marketprice) > 0">¥{{groupInfo.marketprice}}</del></p>
                        <span class="num">{{groupInfo.sales}}人已购买</span>
                    </div>
                </div>
            </div>
            <div class="mall-detail-desc">
                <div class="list">
                    <div class="middle">
                        <span class="left">发货</span>
                        <div class="address">
                            <img src="../assets/location.png" class="location" alt="">
                            <span>{{shopInfo.birth}}</span><i class="line"></i><span>{{groupInfo.freeShippingInfo}}</span>
                        </div>
                       </div>
                </div>
                <div class="list" @click="jumpDownload()" v-if="couponList.length > 0">
                    <div class="middle">
                        <span class="left">优惠</span>
                        <div class="couponlist">
                            <span class="coupon" v-for="(item, index) in couponList" :key="index">{{item.title}}</span>
                        </div>
                    </div>
                    <img src="../assets/right.png" class="right">
                </div>
                <div class="list" @click="jumpDownload()" v-if="equityInfo.length > 0">
                    <div class="middle">
                        <span class="left">保障</span>
                        <div  class="desc  text-overflow_1-xzh">
                            <span v-for="(item, index) in equityInfo" :key="index"><i class="round" v-if="index != 0"></i>{{item}}</span>
                        </div>

                    </div>

                    <img src="../assets/right.png" class="right">
                </div>
            </div>
            <div class="mall-comment mall-common-title">
                <div class="title">
                    <p class="num">宝贝评论({{groupInfo.discussNum}})</p>
                    <span @click="jumpDownload()">查看全部<img src="../assets/redRight.png" alt=""></span>
                </div>
                <div class="info" v-if="discussList.length > 0">
                    <div class="logo">
                        <img :src="discussList[0].userInfo.avatar" alt="">
                        <span>{{discussList[0].userInfo.nickname}}</span>
                    </div>
                    <p class="property text-overflow_1-xzh" >{{discussList[0].created_at | formatDate}} <span v-if="groupInfo.field1">{{groupInfo.field1}}:</span>{{discussList[0].attrInfo.field_1}} <span v-if="groupInfo.field2">{{groupInfo.field2}}:</span>{{discussList[0].attrInfo.field_2}}</p>
                    <h3 class="describe text-overflow_2-xzh">{{discussList[0].info}}</h3>
                    <div class="imgList">
                        <div class="img" v-for="(item, index) in discussList[0].thumbs" :key="index">
                            <img :src="item" alt="" @click="jumpDownload()">
                        </div>
                    </div>
                </div>
            </div>
            <div class="shop-info" v-if="shopInfo">
                <div class="logo"><img :src="shopInfo.logo" alt=""></div>
                <div class="info">
                    <div class="top">
                        <h3>{{shopInfo.title}}</h3>
                        <button @click="jumpDownload()">进店逛逛</button>
                    </div>
                    <div class="bottom">
                        <p v-for="(item, index) in shopInfo.scoreInfo" :key="index">{{scoreTitle[index-1]}}<span :class="{'low': Number(item) < 4}">{{item}}</span><i v-if="Number(item) >= 4">高</i><i v-else-if=" 2 < Number(item) < 4" class="low">平</i><i v-else class="low">低</i></p>
                    </div>
                </div>
            </div>
            <div class="mall-recommend mall-common-title">
                <div class="title">
                    <p class="num">店铺推荐</p>
                    <span @click="jumpDownload()">查看全部<img src="../assets/redRight.png" alt=""></span>
                </div>
                <div class="goodsList">
                    <ul>
                        <li v-for="(item, index) in recommendGoodsList" :key="index" @click="jumpDownload()">
                            <div class="img">
                                <img :src="item.thumb" alt="">
                            </div>
                            <div class="info">
                                <h4 class="goodsTitle text-overflow_2-xzh">{{item.goodsName}}</h4>
                                <p class="price"><span>¥</span>{{item.spe_price}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="goods-details common-title" v-if="groupInfo.info" style="background: #f3f3f3;">
                <h3 class="detail-title">宝贝详情</h3>
                <div class="count" v-html="groupInfo.info">{{groupInfo.info}}</div>
            </div>
            <div class="common-title mall-guess-like" v-if="likeGoodsList.length > 0">
                <h3 class="detail-title">猜你喜欢</h3>
                <div class="list">
                    <ul>
                        <li v-for="(item, index) in likeGoodsList" :key="index" @click="jumpDownload()">
                            <div class="goodsImg">
                                <img :src="item.thumb" alt="">
                            </div>
                            <div class="info">
                                <h3 class="title text-overflow_2-xzh">{{item.goodsName}}</h3>
                                <div class="num">
                                    <span><i>¥</i>{{item.spe_price}}</span><del>¥{{item.marketprice}}</del>
                                </div>
                                <div class="btm">{{item.sales}}人付款</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
    <div style="height:1rem"></div>
    <div class="details-footer mall-detail-footer">
        <div class="btm" @click="jumpDownload()">
            <div class="left">
                <div >
                    <img src="../assets/mall/shouye.png" alt="">
                    <p>首页</p>
                </div>
                <div>
                    <img v-if="isLick == 0" src="../assets/mall/collect.png" alt="">
                    <img v-if="isLick == 1" src="../assets/mall/activeCollect.png" alt="">

                    <p>收藏</p>
                </div>
                <div>
                    <img src="../assets/mall/service.png" alt="">
                    <p>客服</p>
                </div>
            </div>
            <div style="display:flex;width: 4.6rem;justify-content: flex-end;">
                <div class="single" v-if="groupInfo.module == '实物'">
                    加入购物车
                </div>
                <div class="group" :style="{'width': groupInfo.module == '虚拟' ? 4.6 + 'rem' : 2.3 + 'rem'}">
                    立即购买
                </div>
            </div>

        </div>
    </div>
    </div>
</template>
<script>
import { Toast } from 'mint-ui'
import axios from 'axios'
import qs from 'qs'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {formatDate} from '../plugin/data'

export default {
  name: 'commodity',
  components: {
    swiper,
    swiperSlide
  },
  filters: {
    formatDate (time) {
      time = time * 1000
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm')
    }
  },
  data () {
    return {
        code: '',
        codes: false,
        datas: {},
        yujiazai: true,
        dialog: false,
        active1: 0,
        active2: 0,
        swiperOption: {
            autoplay: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
        },
        popupVisible: false,
        buyNum: 1,
        id: '',
        groupInfo: '',
        goodsList: '',
        collage: '',
        shopInfo: '',
        shopInfoTypeInfo: '',
        shareType: false,
        iid: '',
        price: '',
        total: '',
        attrId: '',
        buyType: '',
        selectTitle: '',
        selectSize: '',
        statusH: '',
        mescroll: null,
        collageList: '',
        intNum: undefined,
        animate:false,
        device: '',
        couponPop: false,
        safeguardPop: false,
        moreShow: false,
        equityInfo: [],
        recommendGoodsList: [],
        likeGoodsList: [],
        discussList: [],
        couponList: [],
        buyPopType: '',
        isLick: 0,
        shareInfo: '',
        scoreTitle: ['宝贝描述', '卖家服务', '物流服务'],
        codeVersion: ''
    }
  },
  methods: {
    onError (e) {
      console.error(e)
    },
    jumpDownload () {
      this.$router.push({
        path: '/download',
        query: {code: this.code}
      })
    },
    // 商品详情
    getDetail(goodsId, bizId){
        axios.post(this.GLOBAL.apiUrl + '/api/' + bizId + '/mall/index/goods-detail', {goodsId: goodsId}).then((res) => {
            if(res.data.code === 0){
                this.groupInfo = res.data.data.detail
                this.activityInfo = res.data.data.detail.activityInfo
                this.shopInfo = res.data.data.detail.shopInfo
                this.discussList = res.data.data.detail.discussList
                this.couponList = res.data.data.detail.couponList
                this.shopInfoTypeInfo = res.data.data.detail.shopInfo.typeInfo
                this.equityInfo = res.data.data.detail.equityInfo
                this.buyNum = this.groupInfo.goodsNumMin
                this.isLick = res.data.data.detail.isLike
                // console.log('type', type)
                // if(type == null || type == 'undefined'){
                    this.$nextTick(function(){
                        this.recommendList(goodsId, bizId, this.groupInfo.spid)
                    })
                // }

            }else{
                this.$toast({message: res.data.msg});
            }
        })
    },
    // 推荐列表
    recommendList(goodsId, bizId, spid){
        axios.post(this.GLOBAL.apiUrl + '/api/' + bizId + '/mall/index/goods-list', {notGoodsId: goodsId, spid: spid, isRecommend: '1'}).then((res) => {
            if (res.data.code === 0) {
                this.recommendGoodsList = res.data.data.list
            }
        })
    },
    // 猜你喜欢
    likeList(bizId) {
        axios.post(this.GLOBAL.apiUrl + '/api/' + bizId + '/mall/index/goods-list', {isLike: 1}).then((res) => {
            if(res.data.code === 0) {
                this.likeGoodsList = res.data.data.list;
            }
        })
    },
  },
  mounted () {
    let code = this.GLOBAL.getQueryString('code')
    // let code = 'MTIwXzIwMzcxNw=='
    this.code = code
    let goodsId = this.GLOBAL.getQueryString('goodsid')
    let bizId = this.GLOBAL.getQueryString('biz_id')
    // let bizId = '120'
    this.codeVersion = this.GLOBAL.getQueryString('codeVersion')
    if (!code) {
      this.codes = true
    }
    if (!bizId) {
      bizId = this.GLOBAL.bizId
    }
    axios.defaults.headers = {
      'Content-type': 'application/x-www-form-urlencoded'
    }
    axios.defaults.transformRequest = (data) => {
      data = qs.stringify(data)
      return data
    }
    this.getDetail(goodsId, bizId)
    this.likeList(bizId)
  }
}
</script>
<style lang="less" scoped>
body,div,dl,dt,dd,ul,ol,li,h1,h2,h3,h4,h5,h6,pre,code,form,fieldset,legend,input,textarea,p,blockquote,th,td,hr,button,article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section {
    margin:0;
    padding:0
  }

/*详情*/
#mallGoodsDetails{
    background: #f3f3f3
}
.text-overflow_2-xzh{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
 /deep/.goods-details img{
        width: 100% !important;
 }
 .goods-details .count{
     font-size: 0;
 }
.common-title .detail-title{
    height: .9rem;
    line-height: .9rem;
    display:flex;
    align-items:center;
    justify-content: center;
    font-size: .32rem;
    color: #2f2f2f;
    font-weight: normal;
}
.common-title .detail-title:before, .common-title  .detail-title:after{
    content: '';
    display:inline-block;
    width:1rem;
    background-color:#D6D6D6;
    height:1px;
}
.common-title  .detail-title:before{
    margin-right: .32rem;
}
.common-title  .detail-title:after{
    margin-left: .32rem;
}
.goodsBanner{
    font-size: 0;
}
.goodsBanner .swiper-slide{
    height: 6.9rem;
}
.goodsBanner .swiper-slide img{
    max-height: 6.9rem;
    width: 100%;
}
.goodsBanner .swiper-pagination{
    position:absolute;
    bottom:.32rem;
    left: 100%;
    margin-left: -1.3rem;
    width:0.8rem;
    height:0.44rem;
    border-radius: .22rem;
    background:rgba(0,0,0,1);
    opacity:0.35;
    color:#fff;
    font-size:0.24rem;
    text-align: center;
    line-height:0.44rem;
}
.goods-top .info{
    padding:.3rem;
    background-color:#fff
}
.goods-top .info .title{
    font-size:.3rem;
    color:#2F2F2F;
    height: .7rem;
    line-height: .35rem;
}
.goods-top .info .price{
    margin-top: .16rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.goods-top .info .price p{
    color:#D92B24;
    font-size:.40rem
}
.goods-top .info .price p span{
    font-weight: bold;
}
.goods-top .info .price p i{
    font-size:.28rem;
    font-style: normal;
    margin-right: .05rem;
}
.goods-top .info .price p del{
    font-size:.26rem;
    color:#999;
    margin-left:.18rem
}
.goods-top .info .price .num{
    font-size: .24rem;
    color: #999;
}
    /* 商城 */
.mall-detail-desc{
    margin-top:.2rem;
    background-color:#fff;
    padding: 0 .24rem
}
.mall-detail-desc .list{
    border-bottom:1px solid #eee;
    display:flex;
    align-items:center;
    justify-content: space-between;
    height:.9rem;
    font-size:.26rem;
    color:#2f2f2f;
    padding: 0 .03rem
}
.mall-detail-desc .list .middle .left{
    color:#666;
    margin-right:.3rem
}
.mall-detail-desc .list .middle .desc{
    width: 5.5rem;
}
.mall-detail-desc .list .middle .desc i.round{
    display: inline-block;
    width: 4px;
    height: 4px;
    background: #2f2f2f;
    border-radius: 50%;
    margin: 0 .1rem .05rem;
}
.mall-detail-desc .list .right{
    width:0.14rem;
    height:.24rem
}
.mall-detail-desc .list .middle{
    display:flex;
    align-items:center
}
.mall-detail-desc .list .middle .address{
    display:flex;
    align-items:center
}
.mall-detail-desc .list .middle .address .location{
    width:.21rem;
    height:.24rem;
    margin-right:.1rem
}
.mall-detail-desc .list .middle .address .line{
    display:inline-block;
    width:.02rem;
    height:.22rem;
    background-color: #eee;
    margin: .26rem
}
.mall-detail-desc .list .middle .couponlist{
    width:5.5rem;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.mall-detail-desc .list .middle .coupon{
    display:inline-block;
    font-size: 0.22rem;
    line-height: 0.2rem;
    color: #D92B24;
    position: relative;
    border-radius: 0.03rem;
    background: #FFE9EE;
    padding: .1rem .15rem;
    margin-right:.15rem
}
.mall-detail-desc .list .middle .coupon:after{
    content: '';
    position: absolute;
    right: -0.05rem;
    top: 0.14rem;
    height: 0.12rem;
    width: 0.12rem;
    border-radius: 100%;
    background: #fff;
}
.mall-detail-desc .list .middle .coupon:before{
    content: '';
    position: absolute;
    left: -0.05rem;
    top: 0.14rem;
    height: 0.12rem;
    width: 0.12rem;
    border-radius: 100%;
    background: #fff;
}
/* 评论 */

.mall-common-title{
    background-color:#fff
}
.mall-common-title .title{
    height:.9rem;
    display:flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 .3rem;
}
.mall-common-title .title .num{
    font-size:.3rem;
    color:#333
}
.mall-common-title .title span{
    display:flex;
    align-items:center;
    font-size:.28rem;
    color:#D92B24;

}
.mall-common-title .title span img{
    width:.14rem;
    height: .24rem;
    margin-left:0.18rem
}
.mall-comment{
    margin:.2rem 0;
}
.mall-comment .info{
    padding: 0 .3rem;
    border-top:1px solid #eee
}
.mall-comment .info .logo{
    padding:.2rem 0;
    display:flex;
    align-items:center;
    font-size:.32rem;
    color:#2f2f2f
}
.mall-comment .info .logo img{
    width:.66rem;
    height:.66rem;
    border-radius:50%;
    margin-right:.1rem
}
.mall-comment .info .property{
    font-size:.24rem;
    color:#999999;
    margin-bottom:.2rem
}
.mall-comment .info .describe{
    font-size:.28rem;
    color:#2f2f2f;
    font-weight:normal;
    padding-bottom: .2rem;
}
.mall-comment .info .imgList{
    padding:0 0 .2rem;
    font-size: 0;
    display: flex;
    align-items: center;
    justify-content: normal;
    flex-wrap: wrap;
}
.mall-comment .info .imgList .img{
    width:2.1rem;
    height:2.1rem;
    margin: 0 .07rem 0.1rem;
}
.mall-comment .info .imgList .img img{
    max-width: 100%;
    max-height: 100%;
    border-radius:0.05rem;
}
/* 店铺推荐 */
.mall-recommend .title{
    margin: 0 .3rem;
    border-top: 1px solid #eee;
    padding: 0;
}
.mall-recommend .goodsList{
    padding: 0 .24rem
}
.mall-recommend .goodsList ul{
    display:flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
}
.mall-recommend .goodsList li{
    width: 2.22rem;
    margin:.05rem .06rem .1rem .06rem;
    font-size: 0
}
.mall-recommend .goodsList li .img{
    width: 2.22rem;
    height: 2.22rem;
}
.mall-recommend .goodsList li .img img{
    width: 100%;
    height: 100%;
    border-radius:0.05rem
}
.mall-recommend .goodsList li .info .goodsTitle{
    font-size:.26rem;
    font-weight:normal;
    color:#2f2f2f;
    margin: .18rem 0 .15rem;
    height: .64rem;
    line-height: .34rem;
}
.mall-recommend .goodsList li .info .price{
    color:#D92B24;
    font-size:.32rem
}
.mall-recommend .goodsList li .info .price span{
    font-size:.26rem;
    margin-right:.05rem;
    padding-bottom: .1rem
}
/* 猜你喜欢 */
.mall-guess-like {
    margin-top: .2rem;
}
.mall-guess-like ul{
    display:flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    padding: 0 0.1rem 0.1rem 0.1rem;
}
.mall-guess-like ul li{
    width:3.45rem;
    margin:.05rem .1rem .1rem .1rem;
    background-color:#fff;
    border-radius:.1rem;
    font-size: 0
}
.mall-guess-like ul li .goodsImg img{
    width:3.45rem;
    height: 3.45rem;
    border-radius: .1rem .1rem 0 0;
}
.mall-guess-like ul li .info{
    padding: .18rem .18rem .2rem
}
.mall-guess-like ul li .info .title{
    font-size:0.26rem;
    font-weight:normal;
    color:#2f2f2f;
    height: .64rem;
    line-height: .34rem;
}
.mall-guess-like ul li .info .num{
    margin: .12rem 0 .1rem
}
.mall-guess-like ul li .info .num span{
    font-size:0.32rem;
    color:#D92121;
    font-weight:bold
}
.mall-guess-like ul li .info .num span i{
    font-style:normal;
    font-size:0.24rem;
    margin-right:.02rem
}
.mall-guess-like ul li .info .num del{
    font-size:.24rem;
    color:#999;
    margin-left:.12rem
}
.mall-guess-like ul li .info .btm{
    font-size:.22rem;
    color:#999;
}
.mall-detail-footer .left{
    width: 2.9rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.mall-detail-footer .left img{
    width: .36rem;
}
.mall-detail-footer .btm .single, .mall-detail-footer .btm .group{
    width:2.3rem;
    line-height: 1rem;
    padding:0
}
.goods-top .info .title .status {
    font-size: .22rem;
    font-weight: normal;
    height: .3rem;
    line-height: .3rem;
    background-color: #D92B24;
    padding: 0 .14rem;
    color: #fff;
    border-radius: .15rem;
    margin-right: .15rem;
    display: inline-block;
    position: relative;
    top: -1.5px;
}

.shop-info{
    background-color:#fff;
    padding:.3rem;
    display:flex;
    align-items:center
}
.shop-info .logo{
    width:1rem;
    height:1rem;
    margin-right:.2rem;
    display: flex;
    align-items: center;
}
.shop-info .logo img{
    width:100%;
    border-radius:.05rem
}
.shop-info .info{
    width:5.7rem
}
.shop-info .info .top{
    display:flex;
    align-items:center;
    justify-content: space-between;
    margin-bottom:.28rem
}
.shop-info .info .top h3{
    font-size:.3rem;
    color:#2F2F2F;
    font-weight:normal
}
.shop-info .info .top button{
    height:.44rem;
    line-height:.44rem;
    border:1px solid #D92B24;
    border-radius:.22rem;
    font-size:.24rem;
    color:#D92B24;
    padding: 0 .16rem;
    background: #fff
}
.shop-info .info .bottom{
    display:flex;
    justify-content:space-between
}
.shop-info .info .bottom p{
    font-size:.24rem;
    color:#999
}
.shop-info .info .bottom p span{
    color:#D92B24;
    margin-right: .06rem;
}
.shop-info .info .bottom p i{
    display:inline-block;
    font-style:normal;
    width:.27rem;
    height:.27rem;
    background:rgba(255,233,238,1);
    border-radius:50%;
    font-size:.18rem;
    text-align:center;
    color:#D92B24;
}
.shop-info .info .bottom p .low{
    color: #999;
}
.shop-info .info .bottom p i.low{
    background: #F0F0F0;
}

.details-footer{
    position:fixed;
    bottom:0;
    left:0;
    right:0;
}
.details-footer .btm{
    display:flex;
    align-items: center;
    background: #fff;
}
.details-footer .left{
    width:1.7rem;
    text-align:center
}
.details-footer .left img{
    width:.38rem;
    margin-bottom: .05rem;
}
.details-footer .left p{
    font-size:.22rem;
    color:#666
}
.details-footer .single{
    background:linear-gradient(270deg,rgba(255,145,2,1),rgba(255,185,18,1));
}
.details-footer .group{
    background:linear-gradient(270deg,rgba(217,33,33,1),rgba(255,101,73,1));
}
.details-footer .single,.details-footer .group{
    width:2.9rem;
    text-align:center;
    font-size:.3rem;
    color:#fff;
    padding: .1rem 0
}
.details-footer .single span,.details-footer .group span{
    font-size:.26rem
}
.details-footer .timeEnd{
    height: .86rem;
    line-height:.86rem;
    text-align:center;
    background:rgba(0,0,0,1);
    opacity:0.8;
    color:#fff;
    font-size:.26rem
}
.details-footer .timeEnd span{
    font-size:.3rem;
    padding:0 .05rem
}
.mall-detail-footer .left{
            width: 2.9rem;
            display: flex;
            align-items: center;
            justify-content: space-around;
        }
        .mall-detail-footer .left>div{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        .mall-detail-footer .left img{
            width: .36rem;
        }
        .mall-detail-footer .btm .single, .mall-detail-footer .btm .group{
            width:2.3rem;
            line-height: 1rem;
            padding:0
        }
</style>



// WEBPACK FOOTER //
// src/components/mallGoodsDetails.vue